import { FC } from "react";
import { fournisseurService } from "services";
import { SelectAsyncProps } from "types/select-async.type";
import { buildSelectItem } from "utils/helpers";
import { AutoCompleteAsyncHookForm } from "../AutoComplete";

export const SelectFournisseurAsycForm: FC<SelectAsyncProps> = (props) => {
  const fetchData = async () => {
    const { data } = await fournisseurService.findAll();
    return {
      data: data.map(({ nom, id }) => buildSelectItem(nom, id)),
      hasMore: false,
    };
  };
  return <AutoCompleteAsyncHookForm {...props} fetchData={fetchData} />;
};
